import { gql } from '@apollo/client'

export const GET_SOVI_BY_STORE_CHANNEL = gql`
  query GetSoviByStoreChannel($input: DXOExecutionForZonePathInput!) {
    soviByStoreChannel(input: $input) {
      storeChannel
      sovi
    }
  }
`
